import { camelCase, cloneDeep, difference, fromPairs, keyBy, keys, startCase, union, uniq, intersection } from 'lodash';
import { FieldSectionType } from 'api/field-sections/types';
import { CompanyId, ProjectId } from 'api/models';
import { MemberType, CompanyType } from 'api/models/core-types';
import { ObjectType } from 'api/pushes';
import { FieldType, filterableFieldType, SourceType } from 'api/tasks/field-meta';
import { FieldDataType, FieldTypes as ModuleFieldTypes } from 'components/organisms/module-settings/fields/types';
import { CompaniesStore } from 'stores/companies';
import { Empty, Loaded, Loading, Refreshing } from 'stores/core';
import { MembershipsStore } from 'stores/memberships';
import { TeamsStore } from 'stores/teams';
import { UsersStore } from 'stores/users';
import { FieldHelper } from 'utils/field';
import { getRandomColor } from 'utils/get-random-color';
import { constructUserMeta } from './util';
const EMPTY = {
    byId: {},
    originals: {
        byId: {},
        ids: []
    },
    ids: Empty(),
    byObjectType: {
        [ObjectType.Task]: {
            ids: [],
            enabled: [],
            byFieldName: {},
            byCustomField: {
                true: [],
                false: []
            }
        },
        [ObjectType.Project]: {
            ids: [],
            enabled: [],
            byFieldName: {},
            byCustomField: {
                true: [],
                false: []
            }
        },
        [ObjectType.ProjectPhase]: {
            ids: [],
            enabled: [],
            byFieldName: {},
            byCustomField: {
                true: [],
                false: []
            }
        }
    }
};
export const FIELD_ID_ASSIGNEE = -127;
const FIELD_ID_CREATED_AT = FIELD_ID_ASSIGNEE + 1;
const FIELD_ID_CREATED_BY = FIELD_ID_CREATED_AT + 1;
const FIELD_ID_PROJECT = FIELD_ID_CREATED_BY + 1;
const FIELD_ID_RESPONSIBLE = FIELD_ID_PROJECT + 1;
const FIELD_ID_PRIVATE = FIELD_ID_RESPONSIBLE + 1;
export const FIELD_ID_PROJECT_PHASE_FIELD = FIELD_ID_PRIVATE + 1;
const JIRA_INTEGRATION_FIELD = FIELD_ID_PROJECT_PHASE_FIELD + 1;
const COMPLETED_LATE_BY = JIRA_INTEGRATION_FIELD + 1;
export const FIELD_ID_PROJECT_PHASE_FIELD_WITH_ID = COMPLETED_LATE_BY + 1;
const FIELD_ID_TIME_TRACKED = FIELD_ID_PROJECT_PHASE_FIELD_WITH_ID + 1;
const FIELD_ID_TASK_DEPENDENCY_STATUS = FIELD_ID_TIME_TRACKED + 1;
const FIELD_ID_ASSOCIATED_SPRINT = FIELD_ID_TASK_DEPENDENCY_STATUS + 1;
export const FIELD_ID_CURRENT_SPRINT = FIELD_ID_ASSOCIATED_SPRINT + 1;
const FIELD_ID_BUDGETS = FIELD_ID_CURRENT_SPRINT + 1;
const FIELD_ID_BUDGET_NAMES = FIELD_ID_BUDGETS + 1;
const FIELD_ID_EPIC = FIELD_ID_BUDGET_NAMES + 1;
const FIELD_ID_APPLY_TO_SUBTASK = FIELD_ID_EPIC + 1;
const FIELD_ID_REMAINING_HOURS = FIELD_ID_APPLY_TO_SUBTASK + 1;
const FIELD_ID_TASK_NAME = FIELD_ID_REMAINING_HOURS + 1;
const FIELD_ID_MILESTONE_REV_REC = FIELD_ID_TASK_NAME + 1;
const FIELD_ID_MILESTONE_REV_REC_AMOUNT = FIELD_ID_MILESTONE_REV_REC + 1;
// Add new fields here after FIELD_ID_MILESTONE_REV_REC_AMOUNT
const FIELD_ID_TOTAL_ALLOCATED_MINUTES = FIELD_ID_MILESTONE_REV_REC_AMOUNT + 1;
var FieldLabel = /*#__PURE__*/ function(FieldLabel) {
    FieldLabel["CreatedOn"] = "Created on";
    FieldLabel["StartedOn"] = "Started on";
    FieldLabel["HoursTracked"] = "Hours Tracked";
    FieldLabel["AllocatedHours"] = "Allocated hours";
    FieldLabel["RemainingHours"] = "Remaining Hours";
    FieldLabel["Responsible"] = "Responsible";
    FieldLabel["ProjectPhase"] = "Project Phase";
    FieldLabel["JiraIssue"] = "Jira Issue";
    FieldLabel["DaysCompletedLateBy"] = "Days completed late by";
    FieldLabel["TaskDependencyStatus"] = "Blocking task status";
    FieldLabel["AssociatedSprints"] = "Associated sprints";
    FieldLabel["CurrentSprint"] = "Current sprint";
    FieldLabel["Budgets"] = "Budgets";
    FieldLabel["Epic"] = "Epic";
    FieldLabel["ApplyToSubtask"] = "Apply to subtask";
    FieldLabel["RevRecPlan"] = "RevRec Task";
    FieldLabel["RevRecAmount"] = "RevRec Amount";
    return FieldLabel;
}(FieldLabel || {});
const CreatedAtField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'DATE',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Date,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_CREATED_AT,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'createdAt',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('created_on') : "Created on",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
const CreatedByField = (users, translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate('created_by'),
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'USER',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.SingleUser,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_CREATED_BY,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'createdBy',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            users
        },
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
const TimeTrackedField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'NUMBER',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Number,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_TIME_TRACKED,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'timeEntryMinutes',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('hours_tracked') : "Hours Tracked",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
const TotalAllocatedMinutesField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'NUMBER',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Number,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_TOTAL_ALLOCATED_MINUTES,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'totalAllocatedMinutes',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('project.fields.allocated_hours') : "Allocated hours",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
export const AssociatedSprintsField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'MULTI_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.MultiSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_ASSOCIATED_SPRINT,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'associatedSprints',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('associated_sprints') : "Associated sprints",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            options: []
        },
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
export const CurrentSprintField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.SingleSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_CURRENT_SPRINT,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'sprint',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('current_sprint') : "Current sprint",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            options: []
        },
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
export const EpicField = (epics, isEpicEditable)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.SingleSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_EPIC,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'epic',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: "Epic",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            options: epics.map((x)=>({
                    label: x.epicName,
                    value: x.epicId,
                    color: getRandomColor(x.epicId),
                    active: true
                }))
        },
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEditable: isEpicEditable,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
const RemainingHoursField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'NUMBER',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Number,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_REMAINING_HOURS,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'remainingEffortInMinutes',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('project.fields.remaining_minutes') : "Remaining Hours",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
export const BudgetsField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: '',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: '',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.MultiSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_BUDGETS,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'projectFinancialsBudgets',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('project.fields.budgets') : "Budgets",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            options: []
        },
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
export const BudgetNamesField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Text,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_BUDGET_NAMES,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'projectFinancialsBudgetName',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('project.fields.budgets') : "Budgets",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false
    });
export const ProjectField = (projects, translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate('project'),
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.SingleSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_PROJECT,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'project',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            options: projects.map((x)=>({
                    label: x.projectName,
                    value: x.projectId,
                    color: getRandomColor(x.projectId),
                    active: true
                }))
        },
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
export const ProjectFieldAsTextField = (projects, translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate('project'),
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Text,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_PROJECT,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'project',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            options: projects.map((x)=>({
                    label: x.projectName,
                    value: x.projectId,
                    color: getRandomColor(x.projectId),
                    active: true
                }))
        },
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
export const TaskNameField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_TASK_NAME,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'taskName',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectSubType: 'DEFAULT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate('task_name'),
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Text,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false
    });
export const AssigneeField = (users, teams, projectPlaceholders, translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate('assignee'),
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_ASSIGNEE,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: '',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: '',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Assignee,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'assignee',
        // @TODO remove the user and teams meta as whole when everthing has been migrated to indexedFb
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            users: {
                active_user_ids: [],
                by_project_id: {},
                by_user_id: {},
                non_external_user_ids: []
            },
            teams,
            projectPlaceholders
        },
        // metaData: { users, teams, projectPlaceholders },
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldGroup: '_native',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task
    });
const ResponsibleField = (companies, translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_RESPONSIBLE,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'MULTI_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.MultiSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'responsible',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('responsible') : "Responsible",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        description: translate ? translate('stores.describes_who_is_responsible_for_this_task') : 'Describes who is responsible for this task',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            options: companies.map((x)=>({
                    label: x.companyName,
                    value: x.companyId,
                    color: getRandomColor(x.companyId),
                    active: true
                }))
        }
    });
const PrivateField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'BOOLEAN',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Boolean,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_PRIVATE,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'private',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate('private')
    });
const ProjectPhaseField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Text,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_PROJECT_PHASE_FIELD,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'phaseName',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('project_phase') : "Project Phase",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false
    });
const ProjectPhaseFieldWithId = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.SingleSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_PROJECT_PHASE_FIELD_WITH_ID,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'projectPhaseId',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('project_phase') : "Project Phase",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            options: []
        }
    });
const JiraIntegrationField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Text,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: JIRA_INTEGRATION_FIELD,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'jiraIntegration',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('jira_issue') : "Jira Issue",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false
    });
const CompletedLateBy = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'NUMBER',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'NUMBER',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Number,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: COMPLETED_LATE_BY,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'completedLateBy',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('days_completed_late_by') : "Days completed late by",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            required: false,
            rangeAvailable: false
        }
    });
const taskDependencyStatusField = (options, translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: 'SINGLE_SELECT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: 'TEXT',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.SingleSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_TASK_DEPENDENCY_STATUS,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'taskDependencyStatus',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('blocking_task_status') : "Blocking task status",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        metaData: {
            required: false,
            options
        }
    });
const constructByObjectType = (fields)=>{
    const fields_lookup = keyBy(fields, 'fieldId');
    const ids = keys(fields_lookup).map(Number);
    return {
        byCustomField: {
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            true: ids.filter((x)=>!!fields_lookup[x].customField),
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            false: ids.filter((x)=>!fields_lookup[x].customField)
        },
        byFieldName: fromPairs(fields.map(({ fieldId, fieldName })=>[
                fieldName,
                fieldId
            ])),
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        enabled: ids.filter((x)=>!!fields_lookup[x].isEnabled),
        ids
    };
};
const load = ()=>({ byId, ids, originals, byObjectType })=>({
            byId,
            ids: ids[0] === 'refreshing' || ids[0] === 'loading' ? ids : ids[0] === 'loaded' ? Refreshing(ids) : Loading(),
            originals,
            byObjectType
        });
const putAll = (originals)=>(store)=>{
        const fields = originals.map((field)=>{
            var _ref;
            var _field_metaData;
            return field.fieldName === 'defaultTimeEntryCategory' ? {
                ...field,
                metaData: {
                    ...field === null || field === void 0 ? void 0 : field.metaData,
                    options: ((_ref = field === null || field === void 0 ? void 0 : (_field_metaData = field.metaData) === null || _field_metaData === void 0 ? void 0 : _field_metaData.options) !== null && _ref !== void 0 ? _ref : []).map((option)=>({
                            ...option,
                            value: option.valueStr ? Number(option.valueStr) : option === null || option === void 0 ? void 0 : option.value,
                            color: getRandomColor(option.valueStr ? Number(option.valueStr) : option === null || option === void 0 ? void 0 : option.value)
                        }))
                }
            } : field.fieldName === 'startDateActual' && field.objectType === FieldSectionType.Task && field.fieldLabel === 'Start Date Actual' ? {
                ...field,
                fieldLabel: 'Started on'
            } : field;
        });
        return {
            ...store,
            originals: {
                byId: keyBy(fields, 'fieldId'),
                ids: fields.map(({ fieldId })=>fieldId)
            }
        };
    };
const add = (field)=>({ originals: { byId, ids }, ...store })=>({
            ...store,
            originals: {
                byId: {
                    ...byId,
                    [field.fieldId]: field
                },
                ids: union(ids, [
                    field.fieldId
                ])
            }
        });
const remove = (fieldId)=>({ originals: { byId: { [fieldId]: deleted, ...rest }, ids }, ...store })=>({
            ...store,
            originals: {
                byId: rest,
                ids: difference(ids, [
                    fieldId
                ])
            }
        });
const ApplyToSubtaskField = {
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    fieldType: ModuleFieldTypes.SingleSelect,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    fieldDataType: FieldDataType.Boolean,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    type: FieldType.Boolean,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    customField: false,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    fieldId: FIELD_ID_APPLY_TO_SUBTASK,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    fieldName: 'applyToSubtask',
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    fieldLabel: "Apply to subtask",
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    optionsAvailable: false,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    private: false,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    isEnabled: true,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    objectType: ObjectType.Task,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    sourceType: SourceType.Task,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    userCreated: false
};
const MilestoneRevenueRecognitionTaskField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: ModuleFieldTypes.SingleSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: FieldDataType.Boolean,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Boolean,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_MILESTONE_REV_REC,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'isMilestoneRevenueRecognitionTask',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('task.rev_rec_plan') : "RevRec Task",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEditable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false
    });
const MilestoneTaskRevenueRecognitionAmountField = (translate)=>({
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldType: ModuleFieldTypes.SingleSelect,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldDataType: FieldDataType.Number,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        customField: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        type: FieldType.Number,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldId: FIELD_ID_MILESTONE_REV_REC_AMOUNT,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldName: 'milestoneTaskRevenueRecognitionAmount',
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        fieldLabel: translate ? translate('task.rev_rec_amount') : "RevRec Amount",
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        optionsAvailable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        private: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEnabled: true,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        isEditable: false,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        objectType: ObjectType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        sourceType: SourceType.Task,
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        userCreated: false
    });
export const getBaseFields = ({ users, teams, projectPlaceholders, createdByUsers, projectsArr, companies, statusFieldOptions, translate })=>[
        AssigneeField(users, teams, projectPlaceholders, translate),
        CreatedAtField(translate),
        CreatedByField(createdByUsers, translate),
        TimeTrackedField(translate),
        TotalAllocatedMinutesField(translate),
        ProjectField(projectsArr, translate),
        ResponsibleField(companies, translate),
        PrivateField(translate),
        JiraIntegrationField(translate),
        CompletedLateBy(translate),
        taskDependencyStatusField(statusFieldOptions, translate),
        ProjectPhaseField(translate),
        ProjectPhaseFieldWithId(translate),
        RemainingHoursField(translate),
        MilestoneRevenueRecognitionTaskField(translate),
        MilestoneTaskRevenueRecognitionAmountField(translate),
        ApplyToSubtaskField
    ];
const refresh = (usersStore, teamsStore, membershipsStore, companiesStore, [, currentCompanyId], currentUser, systemBotId, projectsData, filterPointsFieldsFromTaskFields, isMultilineBudgetFeatureEnabled = false, isSprintPlaningFeatureEnabled, isEpicFeatureEnabled, epicsArr, translate = (key)=>key)=>(store)=>{
        var _ref;
        var _task_fields_find_metaData, _task_fields_find;
        if (!TeamsStore.loaded(teamsStore) || !UsersStore.loaded(usersStore) || !CompaniesStore.loaded(companiesStore)) {
            return store;
        }
        const users_list = UsersStore.toList(usersStore);
        const active_users = UsersStore.activeUsers(usersStore);
        const active_user_ids = active_users.map(({ userId })=>userId);
        const non_external_user_ids = active_users.map(({ userId })=>userId);
        const native_user_ids = UsersStore.ofMemberType(MemberType.Native)(usersStore);
        const private_user_ids = UsersStore.ofCompanyId(CompanyId(currentCompanyId))(usersStore);
        const private_active_user_ids = intersection(private_user_ids, active_user_ids);
        const teams = TeamsStore.toList(teamsStore);
        const projectsArr = (_ref = projectsData === null || projectsData === void 0 ? void 0 : projectsData.projects) !== null && _ref !== void 0 ? _ref : [];
        const projectIds = projectsArr.map(({ projectId })=>ProjectId(projectId));
        const projectPlaceholders = {};
        projectIds.forEach((projectId)=>{
            var _ref;
            var _memberships_;
            const memberships = MembershipsStore.ofProject(projectId)(membershipsStore);
            const project_placeholders = (_ref = (_memberships_ = memberships[1]) === null || _memberships_ === void 0 ? void 0 : _memberships_.placeholders) !== null && _ref !== void 0 ? _ref : [];
            projectPlaceholders[projectId[1]] = project_placeholders;
        });
        const users = constructUserMeta({
            membershipsStore,
            usersStore,
            current_company_user_ids: private_user_ids,
            native_user_ids,
            active_user_ids,
            non_external_user_ids,
            current_company_active_user_ids: private_active_user_ids,
            projectIds,
            users_list,
            currentUser
        });
        const companies = union(uniq(projectsArr.map((x)=>x.customer.companyId).filter((x)=>x >= 0)), [
            currentCompanyId
        ]).map(CompanyId).map((x)=>CompaniesStore.ofId(x)(companiesStore)).concat(CompaniesStore.toList(companiesStore).filter((x)=>x.companyType === CompanyType.Partner)).filter(Boolean);
        const [task_fields, project_fields, project_phase_fields] = [
            FieldSectionType.Task,
            FieldSectionType.Project,
            FieldSectionType.ProjectPhase
        ].map((type)=>{
            return store.originals.ids.map((x)=>store.originals.byId[x]).filter(({ objectType })=>objectType === type).map((x)=>({
                    ...x,
                    type: filterableFieldType(x),
                    sourceType: type === FieldSectionType.Task ? SourceType.Task : type === FieldSectionType.Project ? SourceType.Project : SourceType.ProjectPhase
                }));
        });
        // @TODO remove this after testing indexed db implementation
        // commented bacauset the loader is not hiding since members store is empty
        const createdByUsers = {
            active_user_ids: [],
            by_project_id: {},
            by_user_id: {},
            non_external_user_ids: []
        };
        const statusFieldOptions = (_task_fields_find = task_fields.find((field)=>field.fieldName === 'Status')) === null || _task_fields_find === void 0 ? void 0 : (_task_fields_find_metaData = _task_fields_find.metaData) === null || _task_fields_find_metaData === void 0 ? void 0 : _task_fields_find_metaData.options;
        const filteredTaskFields = filterPointsFieldsFromTaskFields ? filterPointsFieldsFromTaskFields(task_fields) : task_fields;
        const baseFields = getBaseFields({
            users,
            teams,
            projectPlaceholders,
            translate,
            createdByUsers,
            projectsArr,
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            companies,
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            statusFieldOptions
        });
        if (isSprintPlaningFeatureEnabled && currentUser.userType !== 'EXTERNAL') {
            baseFields.push(AssociatedSprintsField(translate), CurrentSprintField(translate));
        }
        if (isMultilineBudgetFeatureEnabled) {
            baseFields.push(BudgetNamesField(translate));
        }
        baseFields.push(EpicField(epicsArr !== null && epicsArr !== void 0 ? epicsArr : [], isEpicFeatureEnabled !== null && isEpicFeatureEnabled !== void 0 ? isEpicFeatureEnabled : false));
        const fields_with_metadata = filteredTaskFields.map((f)=>({
                ...f,
                fieldName: camelCase(f.fieldName)
            })).concat(baseFields).map((f)=>{
            var _f_fieldLabel;
            var _f_metaData;
            return {
                ...f,
                fieldLabel: f.fieldName === 'projectFinancialsBudgets' ? translate ? translate('project.fields.budgets') : 'Budgets' : (_f_fieldLabel = f.fieldLabel) !== null && _f_fieldLabel !== void 0 ? _f_fieldLabel : translate ? translate(startCase(f.fieldName)) : startCase(f.fieldName),
                metaData: {
                    ...f.metaData,
                    users: f.fieldDataType === 'USER' && f.fieldName !== 'createdBy' ? users : (_f_metaData = f.metaData) === null || _f_metaData === void 0 ? void 0 : _f_metaData.users
                }
            };
        });
        const transformed_fields = [
            ...fields_with_metadata,
            ...project_fields,
            ...project_phase_fields
        ].map((field)=>{
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            switch(field.type){
                case FieldType.SingleSelect:
                case FieldType.MultiSelect:
                    return {
                        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
                        ...field,
                        metaData: {
                            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
                            ...field.metaData,
                            options: FieldHelper(field).options.allOptions
                        }
                    };
                case FieldType.Assignee:
                case FieldType.Boolean:
                case FieldType.Date:
                case FieldType.Estimate:
                case FieldType.MultiUser:
                case FieldType.SingleUser:
                case FieldType.Number:
                case FieldType.Text:
                default:
                    return field;
            }
        });
        const fields_lookup = keyBy(transformed_fields, 'fieldId');
        const ids = keys(fields_lookup).map(Number);
        return {
            byId: fromPairs(ids.map((x)=>[
                    x,
                    Loaded(fields_lookup[x])
                ])),
            originals: store.originals,
            ids: Loaded(ids),
            byObjectType: {
                [ObjectType.Task]: constructByObjectType(fields_with_metadata),
                [ObjectType.Project]: constructByObjectType(project_fields),
                [ObjectType.ProjectPhase]: constructByObjectType(project_phase_fields)
            }
        };
    };
const loaded = ({ ids: [status] })=>status === 'loaded' || status === 'refreshing';
const refreshing = ({ ids: [status] })=>status === 'refreshing';
const toList = ({ ids: [, fields = []], byId })=>fields.map((x)=>byId[x]).filter(Boolean);
const enabledTaskFields = ({ byId, byObjectType: { [ObjectType.Task]: { enabled } } })=>enabled.map((x)=>byId[x]).filter(Boolean).map(([, x])=>x).filter(Boolean).map((x)=>{
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        if ((x === null || x === void 0 ? void 0 : x.fieldName) === 'projectPhaseId') {
            return cloneDeep(x);
        }
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        return {
            ...x
        };
    });
const allTaskFields = ({ byId, byObjectType: { [ObjectType.Task]: { enabled } } })=>enabled.map((x)=>byId[x]).filter(Boolean).map(([, x])=>x).filter(Boolean).map((x)=>cloneDeep(x));
const getTaskFieldByName = (fieldName)=>({ byId, byObjectType: { [ObjectType.Task]: { byFieldName } } })=>{
        var _byId_byFieldName_fieldName;
        return (_byId_byFieldName_fieldName = byId[byFieldName[fieldName]]) !== null && _byId_byFieldName_fieldName !== void 0 ? _byId_byFieldName_fieldName : Empty();
    };
const getProjectPhaseFieldByName = (fieldName)=>({ byId, byObjectType: { [ObjectType.ProjectPhase]: { byFieldName } } })=>{
        var _byId_byFieldName_fieldName;
        return (_byId_byFieldName_fieldName = byId[byFieldName[fieldName]]) !== null && _byId_byFieldName_fieldName !== void 0 ? _byId_byFieldName_fieldName : Empty();
    };
const getTaskStatusField = (store)=>getTaskFieldByName('status')(store);
const getProjectPhaseStatusField = (store)=>getProjectPhaseFieldByName('Status')(store);
const getProjectStatusFieldId = (store)=>store.byObjectType.PROJECT.byFieldName.Status;
export const FieldsStore = {
    empty: ()=>EMPTY,
    load,
    putAll,
    loaded,
    toList,
    enabledTaskFields,
    allTaskFields,
    add,
    remove,
    refresh,
    refreshing,
    getTaskFieldByName,
    getTaskStatusField,
    getProjectPhaseFieldByName,
    getProjectPhaseStatusField,
    getProjectStatusFieldId
};
